<template>
    <div class="page--add_column">
        <!-- {{data}} -->
        <div v-if="isEdit()" class="add_column_row">
            <el-button type="success" @click="add()"><fa :icon="['fas', 'plus']"/></el-button>
        </div>
        <table>
            <tr >
                <td v-for="(r,i) in showColmun" :key="i">
                    {{$t('field.general.'+r.key)}}
                </td>
                <td v-if="isEdit()">{{$t('field.general.delete')}}</td>
            </tr>
            <tr v-for="(row,index) in activeItemList" :key="index">
                <td v-for="(r,i) in showColmun" :key="i">
                    <el-date-picker :disabled="disableOne(index)" v-if="r.type=='date' && isEdit()" v-model="row[r.key]" type="date" @input="selected" value-format="yyyy-MM-dd" format="yyyy-MM-dd"></el-date-picker>
                    <vue-timepicker  v-else-if="r.type=='time' && isEdit()" v-model="row[r.key]" :disabled="disableOne(index)" @change="selected" format="HH:mm"></vue-timepicker>
                    <input class="text" v-else :disabled="disableOne(index) || isEdit()==false" :placeholder="$t('field.general.'+r.key)" type="text" v-model="row[r.key]" @input="selected">
                </td>
                <td v-if="isEdit()"><el-button type="danger" v-if="disableOne(index)==false" @click="del(row.index)"><fa :icon="['fas', 'trash-alt']"/></el-button></td>
            </tr>
        </table>
    </div>
</template>

<script>
import VueTimepicker from 'vue2-timepicker'

export default {
    props: ['data', 'field', 'k', 'action'],
    components: {VueTimepicker},
    created() {
        let _this=this;
        if(this.field?.param?.column){
            this.column = this.field.param.column;
        }
        if(this.data){
            this.data.map(r=>{
                console.log("r",r)
                _this.add(r);
            })
        }
        
    },
    async beforeMount() {
        
    },
    methods: {
        isEdit(){
            return this.action=='Edit'?true:false;
        },
        add(d){
            // let d={};
            if(d == undefined) d={};
            let obj = {};
            obj["deleted"]=0;
            if(d["deleted"]!=undefined){
                obj["deleted"]=d["deleted"];
            }
            
            obj["index"]=this.column_list.length;
            for(let i in this.column){
                if(d!=undefined && d[this.column[i].key]!=undefined){
                    obj[this.column[i].key]=d[this.column[i].key];
                }
                else {
                    obj[this.column[i].key]="";
                }
            }
            this.column_list.push(obj);
            this.selected();
        },
        del(index){
            console.log("index",index)
            // this.column_list.splice(index, 1);
            this.column_list[index].deleted=1;
            console.log("this.column_list",this.column_list)
            this.selected();
        },
        selected(){
            let obj;
            if(this.field?.param?.output_mode=="RetrunDelete"){
                obj=this.column_list;
            }
            else {
                obj=this.activeItemList;
            }

            if(this.field?.param?.output=="Json"){
                this.$emit("input", JSON.stringify(obj));
            }
            else {
                this.$emit("input", obj);
            }
            // console.log(str);
            
            // if(this.field?.param?.output=="Json"){
            //     this.$emit("input", JSON.stringify(this.column_list));
            // }
            // else {
            //     this.$emit("input", this.column_list);
            // }
            
        },
        disableOne(index){
            if(index===0 && this.field?.param?.disable_one==true){
                return true;
            }
            return false;
        }
    },
    computed: {
        activeItemList: function() {
            return this.column_list.filter((item) => {
                return item.deleted==0;
            })
        },
        // retrunDelete: function() {
        //     return this.column_list.filter((item) => {
        //         return (item.deleted==0 || item.id != undefined);
        //     })
        // },
        showColmun: function (){
            return this.column.filter((item) => {
                return item.is_show;
            })
        }
    },
    data() {
        return {
            column_list:[],
            column:[],
        }
    }
}
</script>

<style lang="scss">
    .page--add_column {
        .text{
            height: 30px;
        }
    }
</style>